import React, { useEffect, useState } from 'react';
import {
    CircularProgress, Grid,
    IconButton,
    Paper,
    Switch,
    TextField,
    Typography,
} from '@material-ui/core';
import {Alert, Autocomplete} from '@material-ui/lab';
import LaunchIcon from '@material-ui/icons/Launch';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import RefreshIcon from '@material-ui/icons/Refresh';
import MaterialTable from 'material-table';
import useStyles from '../styles/styles';
import {useQuery, useMutation} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import TableIcons from '../utils/TableIcons';
import theme from '../styles/theme';
import getEnvironment from "../utils/getEnvironment";
import _ from 'lodash';

const Affiliates = () => {
    const classes = useStyles();
    const env = getEnvironment();
    const [manualLoad, setManualLoad] = useState(false);
    const {loading, error, data, refetch} = useQuery(gql`
        query AllAffiliate {
            allAffiliate {
                totalCount
                nodes {
                    name
                    maskedName
                    key
                    createdAt
                    everflowAffiliateId
                    everflowAffiliateHash
                    id
                    isTest
                    legacyPublisherId
                    companyId
                }
            }
            allTrafficSource {
                nodes {
                    affiliate {
                        id
                        name
                    }
                }
            }
            allCompanies {
                id
                name
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
        context: {
            clientName: "kgraphql"
        }
    });

    const [updateAffiliate, {loading: updateAffiliateLoading, error: updateAffiliateError, data: updateAffiliateData}] = useMutation(gql`
        mutation UpdateAffiliate($input: AffiliateUpdateMutationInput!) {
            updateAffiliate(input: $input) {
                maskedName
                key
                createdAt
                everflowAffiliateId
                everflowAffiliateHash
                id
                isTest
                legacyPublisherId
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    const [createAffiliate, {loading: createAffiliateLoading, error: createAffiliateError, data: createAffiliateData}] = useMutation(gql`
        mutation createAffiliate($input: AffiliateCreateMutationInput!) {
            createAffiliate(input: $input) {
                maskedName
                key
                createdAt
                everflowAffiliateId
                everflowAffiliateHash
                id
                isTest
                legacyPublisherId
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    useEffect(() => {
        if (createAffiliateData && Object.keys(createAffiliateData).length || updateAffiliateData && Object.keys(updateAffiliateData).length) {
            setManualLoad(true);
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        }

    }, [createAffiliateData, updateAffiliateData]);

    useEffect(() => {
        if (!loading && manualLoad) {
            setManualLoad(false);
        }
    }, [loading]);

    const handleKey = (e) => {
        if (e.key === 'Enter') {
            e.stopPropagation()
        }
    }

    const findCompanyName = (option) => {
        const company = data.allCompanies.find( item => item.id === option)
        return company ? company.name : null
    }

    const AffiliateTable = () => (
        <MaterialTable
            title=""
            icons={TableIcons}
            columns={[
                {title: 'Id', field: "id", hidden: true},
                {title: "Name", field: "name",
                    editComponent: props => (
                        <TextField
                            value={props.value}
                            type="text"
                            onChange={e => props.onChange(e.target.value)}
                            error={!props.value}
                            onKeyDown={e => handleKey(e)}
                            className={classes.textField}
                        />
                    )
                },
                {title: "Key", field: "key",
                    editComponent: props => (
                        <TextField
                            value={props.value}
                            type="text"
                            onChange={e => props.onChange(e.target.value)}
                            error={!props.value}
                            onKeyDown={e => handleKey(e)}
                            className={classes.textField}
                        />
                    )
                },
                {
                    title: "Masked Name", field: 'maskedName',
                    render: rowData => rowData.maskedName !== null && rowData.maskedName !== '' ? rowData.maskedName : 'N/A',
                    editComponent: props => (
                        <TextField
                            value={props.value}
                            type="text"
                            onChange={e => props.onChange(e.target.value)}
                            error={!props.value}
                            onKeyDown={e => handleKey(e)}
                            className={classes.textField}
                        />
                    )
                },
                {
                    title: "Everflow Publisher Id", field: 'everflowAffiliateId',
                    editComponent: props => (
                        <TextField
                            value={props.value}
                            type="number"
                            onChange={e => props.onChange(e.target.value)}
                            error={!props.value}
                            onKeyDown={e => handleKey(e)}
                        />
                    )
                },
                {title: 'Everflow Hash Id', field: 'everflowAffiliateHash',
                    editComponent: props => (
                        <TextField
                            value={props.value}
                            type="text"
                            onChange={e => props.onChange(e.target.value)}
                            error={!props.value}
                            onKeyDown={e => handleKey(e)}
                        />
                    )
                },
                {
                    title: 'Legacy Publisher Id', field: 'legacyPublisherId',
                    editComponent: props => (
                        <TextField
                            value={props.value}
                            type="number"
                            onChange={e => props.onChange(e.target.value)}
                            onKeyDown={e => handleKey(e)}
                            className={classes.textField}
                        />
                    )
                },
                {
                    title: 'Test', field: 'isTest',
                    render: rowData => rowData.isTest ? <CheckIcon style={{color: theme.palette.success.main}}/> :
                        <ClearIcon style={{color: theme.palette.error.main}}/>,
                    editComponent: props => (
                        <Switch
                            onChange={e => props.onChange(e.target.checked)}
                            checked={props.value}
                            inputProps={{'aria-label': 'primary checkbox'}}
                        />
                    )
                },
                {
                    title: "Company", field: 'companyId',
                    render: rowData => findCompanyName(rowData.companyId),
                    editComponent: props => (
                        <Autocomplete
                            size="medium"
                            className={classes.autoComplete}
                            value={props.value}
                            options={data.allCompanies.map(entry => entry)}
                            getOptionLabel={(option) => {
                                if (_.has(option, 'name')) {
                                    return option.name;
                                }

                                return findCompanyName(option);
                            }}
                            onChange={(e, newValue) => {
                                if (newValue) {
                                    props.onChange(newValue.id);
                                }
                            }}
                            onKeyDown={e => handleKey(e)}
                            renderInput={(params) => <TextField {...params} label="Company" fullWidth />}
                        />
                    )
                },
                {
                    title: 'Traffic Sources', field: 'trafficSource', editable: 'never',
                    render: rowData => {
                        let arr = [];
                        if (rowData) {
                            arr = data.allTrafficSource.nodes.filter(item => item.affiliate.name === rowData.name);
                        }

                        return arr.length ? (
                            <IconButton
                                onClick={() => window.open(`/info/traffic-sources?affiliateId=${rowData.name}`)}>
                                <LaunchIcon/>
                            </IconButton>
                        ) : 'N/A';
                    }
                }
            ]}
            data={data.allAffiliate.nodes.map(affiliate => ({
                id: affiliate.id,
                name: affiliate.name,
                maskedName: affiliate.maskedName,
                key: affiliate.key,
                everflowAffiliateId: affiliate.everflowAffiliateId,
                everflowAffiliateHash: affiliate.everflowAffiliateHash,
                legacyPublisherId: affiliate.legacyPublisherId,
                isTest: affiliate.isTest,
                companyId: affiliate.companyId,
                trafficSource: ''
            }))}
            editable={{
                onRowAdd: env === 'test' ? newData =>
                    new Promise((resolve, reject) => {
                        setTimeout(() => {
                            createAffiliate({
                                variables: {
                                    input: {...newData}
                                }
                            });

                            setManualLoad(true);
                            if (!createAffiliateLoading) {
                                refetch();
                                resolve();
                            }

                        }, 1000);
                    }) : null,
                onRowUpdate: env === 'test' ? (newData, oldData) =>
                    new Promise((resolve, reject) => {
                        setTimeout(() => {
                            delete newData.trafficSource
                            updateAffiliate({
                                variables: {
                                    input: {...newData}
                                }
                            });
                            setManualLoad(true);
                            if (!updateAffiliateLoading) {
                                refetch();
                                resolve();
                            }
                        }, 1000);
                    }) : undefined,
            }}
            actions={[
                {
                    icon: () => <RefreshIcon/>,
                    tooltip: 'Refetch Data',
                    isFreeAction: true,
                    onClick: (event) => refetch()
                },
            ]}
            options={{
                addRowPosition: 'first',
                pageSize: 100,
                pageSizeOptions: [100, 200, 300],
                headerStyle: {
                    minWidth: 'auto',
                }
            }}
        />
    );

    return (
        <>
            <Typography variant="h2">
                Affiliates
            </Typography>
            {(!loading && error) || (!createAffiliateLoading && createAffiliateError) || (!updateAffiliateLoading && updateAffiliateError) ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify((error || createAffiliateError || updateAffiliateError), null, 2)}</pre>
                </Paper>
            ) : null}
            {loading || manualLoad ? (
                <Paper className={classes.paper}>
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                </Paper>
            ) : null}
            {!manualLoad && data && data.allAffiliate.nodes ? (
                <AffiliateTable/>
            ) : null}
        </>
    );
};

export default Affiliates;
